import { put } from 'redux-saga/effects'
import { fetchCampaignByIdAction } from '../../handles'
import { fetchCampaignById, FetchCampaignByIdResponse } from '../_http/campaign'

export function* fetchCampaignByIdSaga(action: ReturnType<typeof fetchCampaignByIdAction.request>) {
  try {
    const { campaignId } = action.payload

    const response: FetchCampaignByIdResponse = yield fetchCampaignById({
      campaignId
    })

    yield put(fetchCampaignByIdAction.success({ campaign: response.campaign }))
  } catch (error) {
    console.log('fetchCampaignByIdSaga', error)
    yield put(fetchCampaignByIdAction.failure())
  }
}
